module.exports = __webpack_public_path__ + "static/media/05_MINS-2.0-Q-14.0-TI-SC_1.a1d8027c.png";